module.exports = __webpack_public_path__ + "static/media/26.8b8fd971.jpg";